import { render } from "./Modulos.vue?vue&type=template&id=b9d898e2&scoped=true"
import script from "./Modulos.vue?vue&type=script&lang=js"
export * from "./Modulos.vue?vue&type=script&lang=js"

import "./Modulos.vue?vue&type=style&index=0&id=b9d898e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d898e2"]])

export default __exports__